// Textos do bloco fixo no topo de cada card, por etapa do processo:
// o que está acontecendo, o que depende do cliente e quanto costuma demorar.
// Mesma tabela usada nos e-mails e no WhatsApp.
export const dataEtapas = {
  documentacao: {
    acontecendo: "Aguardamos os documentos da lista.",
    depende:
      "Reunir, apostilar (quando indicado) e enviar pelos Correios com o PT no envelope.",
    demora: "Depende de você. Conferimos em até 5 dias úteis após chegar.",
  },
  analise: {
    acontecendo: "Nossa equipe confere cada documento.",
    depende: "Nada. Se faltar algo, avisamos.",
    demora: "Até 10 dias úteis.",
  },
  obstaculo: {
    acontecendo: "Encontramos um problema que impede o envio.",
    depende:
      "Se precisarmos de algo seu, avisamos. Fale com a gente se tiver dúvida.",
    demora: "Depende da solução. Avisamos quando resolver.",
  },
  apostilamento: {
    acontecendo:
      "Os documentos aprovados estão sendo apostilados (ou já vieram apostilados).",
    depende: "Nada.",
    demora: "Até 15 dias.",
  },
  despacho: {
    acontecendo: "Montamos o processo para envio a Portugal.",
    depende: "Nada.",
    demora: "Até 10 dias.",
  },
  // Plano 2026: o cliente paga a taxa da conservatória. Com link de
  // pagamento (filho maior/neto, aquisição, transcrição) ele paga pelo
  // card e anexa o comprovante; sem link (homologações) acerta com a
  // equipe pelo WhatsApp. Menor de idade não paga taxa (usa "despacho").
  despacho2026: {
    acontecendo: "Montamos o processo para envio a Portugal.",
    depende:
      "Pagar a taxa da conservatória pelo botão do card e anexar o comprovante.",
    demora: "Até 10 dias após o comprovante.",
  },
  despacho2026Equipe: {
    acontecendo: "Montamos o processo para envio a Portugal.",
    depende: "Pagar a taxa da conservatória; combine com a equipe pelo WhatsApp.",
    demora: "Até 10 dias após a taxa.",
  },
  portugal: {
    acontecendo: "O pedido está na conservatória.",
    depende: "Nada. Com senha, você pode consultar no site da Justiça.",
    demora: "Previsão no card; informação oficial do IRN quando houver.",
  },
  exigencia: {
    acontecendo: "A conservatória pediu um complemento.",
    depende: "Só se precisarmos de documento seu; avisamos.",
    demora: "Depende da conservatória. Quando houver previsão, ela aparece no card.",
  },
  concluido: {
    acontecendo: "A conservatória concluiu. O assento foi emitido.",
    depende:
      "Baixar o assento e, se quiser, pedir cartão de cidadão e passaporte.",
    demora: "—",
  },
  // Plano Análise (22/10/2026): documentos digitais, laudo, continuação.
  analiseDocumentos: {
    acontecendo: "Aguardamos a foto ou o PDF de cada documento da lista.",
    depende:
      "Emitir os documentos, enviar aqui pelo celular ou computador e dizer se já estão apostilados. Guarde os originais.",
    demora: "Depende de você. A análise começa quando o último documento chegar.",
  },
  analiseEmAndamento: {
    acontecendo: "Recebemos todos os documentos. Nossa equipe está analisando.",
    depende: "Nada. O envio de documentos está fechado.",
    demora: "Laudo em até 7 dias após o último documento.",
  },
  analiseLaudo: {
    acontecendo: "A análise terminou e o laudo foi emitido. Ele está no card e no seu e-mail.",
    depende: "Ler o laudo e falar com o seu consultor sobre a continuação do processo.",
    demora: "—",
  },
  analiseAguardandoContinuacao: {
    acontecendo: "A continuação do processo já foi montada pelo seu consultor (Plano 2026 com o valor da análise abatido).",
    depende: "Assinar o contrato e pagar pelos links que chegam por e-mail. Depois o novo pedido aparece aqui.",
    demora: "—",
  },
};

// step.name -> chave em dataEtapas
export const etapaPorStep = {
  documentation: "documentacao",
  incomplete_documentation: "documentacao",
  complete_documentation: "analise",
  blocked: "obstaculo",
  blocked_post: "obstaculo",
  hague: "apostilamento",
  docs_ok: "apostilamento",
  unblocked: "apostilamento",
  post: "despacho",
  monitoring: "portugal",
  approved: "portugal",
  dispatched: "portugal",
  requirement: "exigencia",
  analise_documentos: "analiseDocumentos",
  analise_em_andamento: "analiseEmAndamento",
  analise_laudo: "analiseLaudo",
  analise_aguardando_continuacao: "analiseAguardandoContinuacao",
};
